import { IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { downloadFile } from '../../../../canopy-ui-components/api/download';
import ActDl from '../../../../canopy-ui-components/components/Icons/ActDl';
import * as ga from '../../../../canopy-ui-components/google-analytics/index';
import { useCurrentColors } from '../../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import DownloadUnavailableModal from './DownloadUnavailableModal';
export function DownloadFileAction({
    data,
    globalProps: { t },
}: Record<string, any>) {
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const currentColors = useCurrentColors();
    const onClose = () => {
        setOpenModal(false);
    };
    const handleDownload = async () => {
        setIsLoading(true);
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Download File`,
            fileName: data[0]?.fileName,
        });
        if (
            data &&
            data[0].fileType === 'Statement' &&
            data[0].status === 'expired'
        ) {
            setOpenModal(true);
        } else {
            setOpenModal(false);
            await downloadFile({
                url: `documents/generate-hash?document_id=${data[0]?.documentId}`,
                fetchKey: true,
            });
        }
        setIsLoading(false);
    };
    return (
        <>
            <DownloadUnavailableModal
                openModal={openModal}
                setOpenModal={setOpenModal}
                onClose={onClose}
                t={t}
            />
            <Tooltip
                aria-label="download"
                label={t('ui.mm.tooltip.download')}
                placement="bottom-start"
                hasArrow
            >
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    width="20px !important"
                    minWidth="20px !important"
                    height="20px !important"
                    icon={<ActDl />}
                    aria-label="download"
                    data-test="download"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    _hover={{
                        backgroundColor: 'transparent',
                    }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{
                        border: '0px',
                    }}
                    isLoading={isLoading}
                    onClick={handleDownload}
                ></IconButton>
            </Tooltip>
        </>
    );
}

export default DownloadFileAction;
